module.exports = __webpack_public_path__ + "static/media/norppalogo.c02d93c6.jpg";